module.exports = __webpack_public_path__ + "img/takeout.de383685.png";